import { defineMessages } from 'react-intl';

export default defineMessages({
    error: {
        id: '_.confirmation_button.error',
        defaultMessage: 'Error'
    }
});
